// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"b74509e6","377":"33e43d08","417":"01ddc27e","467":"3b668e94","626":"e5e40771","870":"fac2d117"}[chunkId] + ".js";
};